//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectFaceList.js";
import "../Mechatronics/Mechatronics.DynamicMaterialPointBuilderList.js";
import "../Mechatronics/Mechatronics.SelectRigidBody.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AxisVector",1,"Direction",0],[1,"BoxXlen",0,"Expression",0],[1,"BoxYlen",0,"Expression",0],[1,"BoxZlen",0,"Expression",0],[0,"Category",1,0],[1,"CylinderHeight",0,"Expression",0],[1,"CylinderRadius",0,"Expression",0],[1,"Faces",0,"SelectFaceList",0],[1,"GuideOffset",0,"Expression",0],[0,"GuideVector",1,"Direction",0],[0,"Mode",1,0],[0,"Name",1,0],[1,"Offset",0,"Expression",0],[0,"Orientation",1,"CoordinateSystem",0],[1,"PointList",0,"Mechatronics.DynamicMaterialPointBuilderList",0],[0,"PointOnGuide",1,"Point",0],[0,"ShapeOption",1,0],[1,"Superseded",0,"Mechatronics.SelectRigidBody",0]],[[["superseded"],"SetSuperseded",{},1,0],[["faces"],"SetFaces",{},1,0],[["n_curves"],"GetSectionCurves",{R_:{curves:"NXObject[]"}},0,0],[["curves"],"SetSectionCurves",{},1,0],[["n_curves"],"GetGuideCurves",{R_:{curves:"NXObject[]"}},0,0],[["curves"],"SetGuideCurves",{},1,0],[[],"NewDrivePoint",{R_:{drivePointBuilder:"Mechatronics.DynamicMaterialPointBuilder"}},0,0],[["n_exps"],"GetVariableExps",{R_:{exps:"NXObject[]"}},0,0],[["exps"],"SetVariableExps",{},1,0],[["curves"],"EvaluateSection",{},1,0],[["curves"],"EvaluateGuideSection",{},1,0]],[]];
SPLM.Mechatronics.DynamicMaterialBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.DynamicMaterialBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.DynamicMaterialBuilder.MaterialMode = Object.freeze({
    "Box" : "Box", "Cylinder" : "Cylinder", "UserDefined" : "UserDefined", "AlongGuide" : "AlongGuide", "DynamicVariables" : "DynamicVariables"});

SPLM.Mechatronics.DynamicMaterialBuilder.ShapeType = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

export default SPLM;